import { getPoliciesForPatient } from './getPoliciesForPatient/getPoliciesForPatient';

export const endpoint = '/api/v1/patient-policies/';

const patientPolicies = {
  getPoliciesForPatient,
};

export default patientPolicies;
